var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToolBarNoiseMeter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Icon_ToolBar_NoiseMeter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 36",
    d: "M64 30.5C64 22.4109 60.7866 14.6531 55.0668 8.93324C49.3469 3.21338 41.5891 6.1071e-07 33.5 0C25.4109 -6.1071e-07 17.6531 3.21338 11.9332 8.93324C6.21339 14.6531 3 22.4109 3 30.5H9.95736C9.95736 24.2561 12.4377 18.2679 16.8528 13.8528C21.2679 9.43774 27.2561 6.95736 33.5 6.95736C39.7439 6.95736 45.7321 9.43774 50.1472 13.8528C54.5623 18.2679 57.0426 24.2561 57.0426 30.5H64Z",
    fill: "#F998BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 7",
    d: "M30.2457 26.6344C32.2765 24.4874 43.2988 15.9636 45.226 17.7864C47.1533 19.6093 39.2557 31.0886 37.2249 33.2356C35.1941 35.3827 31.9855 35.6454 30.0583 33.8225C28.131 31.9997 28.215 28.7814 30.2457 26.6344Z",
    fill: "#F998BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.38672 48.5105H11.5867L21.1867 38.8182L28.3867 56.8182L40.3867 45.6154L49.9867 51.5315L57.1867 48.5105H64.3867",
    stroke: "#F998BC",
    strokeWidth: 7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolBarNoiseMeter);
export default __webpack_public_path__ + "static/media/Icon_ToolBar_NoiseMeter.e6c7afa5cf882d3f5563d253bb1a0fe6.svg";
export { ForwardRef as ReactComponent };